// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"373":"25833d3e","500":"c399357b","590":"33946018"}[chunkId] + ".chunk.js";
};